import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationOptions } from 'react-query';

import useAPIMutation from '../api/useAPIMutation';
import {
  AlwaysVisibleRegistrationFieldType,
  JobPostingDetail,
  JobPostingId,
  RegistrationFieldType,
} from '../types';
import { JobPostingDetailInputSerializer } from '../types/api';

type UseUpdateJobPostingRegistrationTemplateProps = Omit<
  UseMutationOptions<
    AxiosResponse<JobPostingDetail>,
    AxiosError,
    UseUpdateJobPostingRegistrationTemplateVariables,
    unknown
  >,
  'mutationFn'
>;

type MutationRegistrationTemplate = {
  linkedinOrResume: AlwaysVisibleRegistrationFieldType;
  pcdReport: RegistrationFieldType;
} & Omit<
  NonNullable<JobPostingDetailInputSerializer['custom_registration_template']>,
  'linkedin_or_resume' | 'pcd_report'
>;

type UseUpdateJobPostingRegistrationTemplateVariables = {
  jobPostingId: ReturnType<typeof JobPostingId>;
  registration_template: JobPostingDetailInputSerializer['registration_template'];
} & MutationRegistrationTemplate;

const useUpdateJobPostingRegistrationTemplate = (
  options?: UseUpdateJobPostingRegistrationTemplateProps
) => {
  return useAPIMutation(
    (
      {
        jobPostingId,
        registration_template,
        address,
        birthday,
        cid,
        cpf,
        linkedin,
        pcd,
        portfolio,
        relocation,
        resume,
        salary,
        travel,
        linkedinOrResume,
        pcdReport,
      }: UseUpdateJobPostingRegistrationTemplateVariables,
      api
    ) => {
      if (registration_template) {
        return api.patch(`/job-postings/${jobPostingId}/`, {
          registration_template,
          custom_registration_template: null,
        });
      }

      return api.patch(`/job-postings/${jobPostingId}/`, {
        registration_template: null,
        custom_registration_template: {
          address,
          birthday,
          cid,
          cpf,
          linkedin,
          linkedin_or_resume: linkedinOrResume,
          pcd,
          pcd_report: pcdReport,
          portfolio,
          relocation,
          resume,
          salary,
          travel,
        },
      });
    },
    options
  );
};

export default useUpdateJobPostingRegistrationTemplate;
